/*
 * TOMYRIS CUSTOM: Виджет подбора размера бра (пуш-ап со слэш-размерами).
 * Спека: docs/plans/bra-size-widget.md
 *
 * Этот файл — ЯДРО: чистая функция calculate(config, u, b) -> state object (без DOM)
 * + реестр конфигов на товар. UI-обвязка (рендер в drawer) добавляется отдельно.
 *
 * UMD-обёртка: в браузере вешается на window.TomyrisBraFit,
 * в Node экспортится через module.exports — чтобы прогонять unit-тесты (tests/).
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.TomyrisBraFit = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // ── Состояния (ТЗ §6) ──────────────────────────────────────────────
  var STATE = {
    RESULT:         'RESULT',
    RESULT_ALT_CUP: 'RESULT_ALT_CUP',
    RESULT_ALT_BAND:'RESULT_ALT_BAND',
    GAP_SUGGEST:    'GAP_SUGGEST',
    GAP_WHATSAPP:   'GAP_WHATSAPP',
    OUT_OF_GRID:    'OUT_OF_GRID',
    INVALID_INPUT:  'INVALID_INPUT'
  };

  // ── Реестр конфигов на товар (ТЗ §2). ──────────────────────────────
  // Добавить второй бра с чашками = добавить объект сюда, логику НЕ трогать.
  var CONFIGS = {
    'tomyris-push-up-bra': {
      productKey: 'tomyris-push-up-bra',
      units: 'cm',
      input: {
        underbust: { uiMin: 65, uiMax: 115, step: 1, default: 80 },
        bust:      { uiMin: 75, uiMax: 130, step: 1, default: 93 }
      },
      grid: { underbustMin: 73, underbustMax: 102, diffMin: 10, diffMax: 19 },
      cupLegend: [
        { diff: [10, 11], cup: 'A' },
        { diff: [12, 13], cup: 'B' },
        { diff: [14, 15], cup: 'C' },
        { diff: [16, 17], cup: 'D' },
        { diff: [18, 19], cup: 'E' }
      ],
      // bust — справочная колонка «Грудь, см» из портала gbc_portal (модель MDL-0047,
      // fit_size_values.bust). ТОЛЬКО для отображения в таблице; подбор размера
      // по-прежнему идёт по diff (обхват груди − обхват под грудью), см. cupLegend.
      // ⚠️ Портальные bust НЕ выводятся из diff (см. docs/plans/bra-size-widget.md).
      bands: [
        { rus: 75,  int: 34, underbust: [73, 77],
          skus: [ { label: 'B/C', diff: [12, 15], bust: [85, 89],   variantKey: '75B/C' },
                  { label: 'D/E', diff: [16, 19], bust: [89, 93],   variantKey: '75D/E' } ] },
        { rus: 80,  int: 36, underbust: [78, 82],
          skus: [ { label: 'B/C', diff: [12, 15], bust: [89, 93],   variantKey: '80B/C' },
                  { label: 'D/E', diff: [16, 19], bust: [93, 97],   variantKey: '80D/E' } ] },
        { rus: 85,  int: 38, underbust: [83, 87],
          skus: [ { label: 'B/C', diff: [12, 15], bust: [93, 97],   variantKey: '85B/C' },
                  { label: 'D/E', diff: [16, 19], bust: [97, 101],  variantKey: '85D/E' } ] },
        { rus: 90,  int: 40, underbust: [88, 92],
          skus: [ { label: 'C/D', diff: [14, 17], bust: [97, 101],  variantKey: '90C/D' } ] },
        { rus: 95,  int: 42, underbust: [93, 97],
          skus: [ { label: 'C/D', diff: [14, 17], bust: [103, 107], variantKey: '95C/D' } ] },
        { rus: 100, int: 44, underbust: [98, 102],
          skus: [ { label: 'C/D', diff: [14, 17], bust: [107, 111], variantKey: '100C/D' } ] }
      ],
      whatsapp: {
        phone: '77786059286',
        messageTemplate: 'Здравствуйте! Подбираю размер «Пуш-ап бюстгальтер TOMYRIS». Обхват под грудью: {u} см, обхват груди: {b} см. Помогите, пожалуйста, с размером.'
      }
    }
  };

  // ── Хелперы ────────────────────────────────────────────────────────
  function inRange(x, range) { return x >= range[0] && x <= range[1]; }

  function cupByDiff(config, diff) {
    for (var i = 0; i < config.cupLegend.length; i++) {
      if (inRange(diff, config.cupLegend[i].diff)) return config.cupLegend[i].cup;
    }
    return null;
  }
  function findBand(config, u) {
    for (var i = 0; i < config.bands.length; i++) {
      if (inRange(u, config.bands[i].underbust)) return config.bands[i];
    }
    return null;
  }
  function skuByDiff(band, diff) {
    for (var i = 0; i < band.skus.length; i++) {
      if (inRange(diff, band.skus[i].diff)) return band.skus[i];
    }
    return null;
  }
  function skuByLabel(band, label) {
    for (var i = 0; i < band.skus.length; i++) {
      if (band.skus[i].label === label) return band.skus[i];
    }
    return null;
  }
  function bandByUpper(config, val) {
    for (var i = 0; i < config.bands.length; i++) {
      if (config.bands[i].underbust[1] === val) return config.bands[i];
    }
    return null;
  }
  function bandByLower(config, val) {
    for (var i = 0; i < config.bands.length; i++) {
      if (config.bands[i].underbust[0] === val) return config.bands[i];
    }
    return null;
  }
  function sizeRus(band, sku) { return String(band.rus) + sku.label; }
  function sizeInt(band, sku) { return String(band.int) + sku.label; }

  // ── Хелперы пути «Знаю размер» ──────────────────────────────────────
  var CUP_ORDER = 'ABCDE';
  function cupRank(c) { return CUP_ORDER.indexOf(c); }
  function bandByRus(config, rus) {
    for (var i = 0; i < config.bands.length; i++) {
      if (config.bands[i].rus === rus) return config.bands[i];
    }
    return null;
  }
  // Чашки, которые кроет sku-метка: 'B/C' → ['B','C'], 'C/D' → ['C','D'].
  function cupsOf(label) { return String(label).split('/'); }
  // sku на поясе, кроющий запрошенную чашку (точное попадание).
  function skuByCup(band, cup) {
    for (var i = 0; i < band.skus.length; i++) {
      if (cupsOf(band.skus[i].label).indexOf(cup) !== -1) return band.skus[i];
    }
    return null;
  }

  // ── Ядро подбора (ТЗ §4). Проверки строго по порядку. ──────────────
  function calculate(config, u, b) {
    u = Math.round(u);
    b = Math.round(b);
    var diff = b - u;

    // ШАГ 1: перепутанные поля / измерение в утяжке
    if (b <= u || diff <= 9) {
      return { state: STATE.INVALID_INPUT, u: u, b: b, diff: diff };
    }
    // ШАГ 2: разница больше сетки
    if (diff > config.grid.diffMax) {
      return { state: STATE.OUT_OF_GRID, u: u, b: b, diff: diff, reason: 'diff' };
    }
    // ШАГ 3: пояс вне сетки
    if (u < config.grid.underbustMin || u > config.grid.underbustMax) {
      return { state: STATE.OUT_OF_GRID, u: u, b: b, diff: diff, reason: 'underbust' };
    }

    // ШАГ 4: базовый расчёт (band и cup всегда находятся после шагов 1-3)
    var band = findBand(config, u);
    var cup = cupByDiff(config, diff);
    var sku = skuByDiff(band, diff);

    // ШАГ 5: дыра ассортимента — нужной чашки на поясе нет
    if (!sku) {
      var nearest = null; // ближайший SKU с чашкой КРУПНЕЕ нужной (асимметрия риска)
      for (var i = 0; i < band.skus.length; i++) {
        var s = band.skus[i];
        if (s.diff[0] > diff && (!nearest || s.diff[0] < nearest.diff[0])) nearest = s;
      }
      if (nearest) {
        return {
          state: STATE.GAP_SUGGEST, u: u, b: b, diff: diff, cup: cup,
          bandRus: band.rus,
          nearestSizeRus: sizeRus(band, nearest),
          nearestSizeInt: sizeInt(band, nearest),
          nearestVariantKey: nearest.variantKey
        };
      }
      return { state: STATE.GAP_WHATSAPP, u: u, b: b, diff: diff, cup: cup, bandRus: band.rus };
    }

    // ШАГ 6: точный результат + флаги границ
    var res = {
      u: u, b: b, diff: diff, cup: cup,
      sizeRus: sizeRus(band, sku),
      sizeInt: sizeInt(band, sku),
      variantKey: sku.variantKey,
      explanation: 'разница ' + diff + ' см → чашка ' + cup
    };

    var altCup = null;
    var altBand = null, altBandBand = null, bandEdge = null;

    // 6a. Граница чашек — только если на поясе два SKU
    if (band.skus.length === 2) {
      if (diff === 15) altCup = skuByLabel(band, 'D/E');
      else if (diff === 16) altCup = skuByLabel(band, 'B/C');
    }

    // 6b. Край пояса (диапазоны встык, «ровно между» при целом вводе не существует)
    if (u === band.underbust[0]) {
      var prev = bandByUpper(config, u - 1);
      if (prev) {
        var ps = skuByDiff(prev, diff);
        if (ps) { altBand = ps; altBandBand = prev; bandEdge = 'lower'; }
      }
    } else if (u === band.underbust[1]) {
      var next = bandByLower(config, u + 1);
      if (next) {
        var ns = skuByDiff(next, diff);
        if (ns) { altBand = ns; altBandBand = next; bandEdge = 'upper'; }
      }
    }

    // Приоритет: максимум одна альтернатива, altCup важнее altBand
    if (altCup) {
      res.state = STATE.RESULT_ALT_CUP;
      res.boundary = diff; // 15 (primary B/C) или 16 (primary D/E) — для текста §7.5
      res.altSizeRus = sizeRus(band, altCup);
      res.altSizeInt = sizeInt(band, altCup);
      res.altVariantKey = altCup.variantKey;
      return res;
    }
    if (altBand) {
      res.state = STATE.RESULT_ALT_BAND;
      res.bandEdge = bandEdge; // 'upper' (свободнее) | 'lower' (плотнее) — для текста §7.6
      res.altSizeRus = sizeRus(altBandBand, altBand);
      res.altSizeInt = sizeInt(altBandBand, altBand);
      res.altVariantKey = altBand.variantKey;
      return res;
    }
    res.state = STATE.RESULT;
    return res;
  }

  // ── Путь «Знаю размер»: пояс (RUS) + чашка → наш слэш-размер ─────────
  // Клиент называет свой размер (85C), переводим в наш «тянущийся» (85B/C).
  // Возвращает тот же объект-состояние, что calculate → renderResult работает без правок.
  // Асимметрия риска та же: если точной чашки нет — предлагаем только КРУПНЕЕ (никогда мельче).
  function calculateFromSize(config, bandRus, cup) {
    var band = bandByRus(config, bandRus);
    if (!band) { return { state: STATE.OUT_OF_GRID, bandRus: bandRus, cup: cup, reason: 'band' }; }

    var sku = skuByCup(band, cup);
    if (sku) {
      return {
        state: STATE.RESULT, cup: cup, bandRus: band.rus,
        sizeRus: sizeRus(band, sku), sizeInt: sizeInt(band, sku),
        variantKey: sku.variantKey,
        explanation: 'размер ' + band.rus + cup + ' → ' + sizeRus(band, sku)
      };
    }

    // Точной чашки на поясе нет → ближайший sku с чашкой КРУПНЕЕ нужной.
    var nearest = null, nearestRank = 999;
    for (var i = 0; i < band.skus.length; i++) {
      var cups = cupsOf(band.skus[i].label);
      var minRank = Math.min(cupRank(cups[0]), cupRank(cups[cups.length - 1]));
      if (minRank > cupRank(cup) && minRank < nearestRank) { nearest = band.skus[i]; nearestRank = minRank; }
    }
    if (nearest) {
      return {
        state: STATE.GAP_SUGGEST, cup: cup, bandRus: band.rus,
        nearestSizeRus: sizeRus(band, nearest), nearestSizeInt: sizeInt(band, nearest),
        nearestVariantKey: nearest.variantKey
      };
    }
    return { state: STATE.GAP_WHATSAPP, cup: cup, bandRus: band.rus };
  }

  // ── WhatsApp-ссылка с подставленными мерками (ТЗ §6) ────────────────
  function whatsappLink(config, u, b) {
    var msg = config.whatsapp.messageTemplate
      .replace('{u}', String(u))
      .replace('{b}', String(b));
    return 'https://wa.me/' + config.whatsapp.phone + '?text=' + encodeURIComponent(msg);
  }

  return {
    STATE: STATE,
    CONFIGS: CONFIGS,
    getConfig: function (key) { return CONFIGS[key]; },
    calculate: calculate,
    calculateFromSize: calculateFromSize,
    whatsappLink: whatsappLink
  };
});
